// extracted by mini-css-extract-plugin
export default {"showMoreText":"LifestyleCalculatorForm_showMoreText__Zv2o8","buttonsWrapper":"LifestyleCalculatorForm_buttonsWrapper__E27el"};